import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center" data-id="element-76">
        <h1 className="text-3xl sm:text-5xl md:text-6xl font-serif font-bold text-brand-text-dark leading-tight mb-4" data-id="element-77">
          Do You Have Hypothyroidism and No Idea What to Eat?
        </h1>

        <p className="text-lg sm:text-xl text-brand-text-muted leading-relaxed mb-6 max-w-3xl mx-auto" data-id="element-78">
          Discover 60 delicious thyroid-friendly recipes designed to help you
          feel more energized, more organized and more like yourself again.
        </p>

        <div className="mb-6" data-id="element-79">
          <a href="#pricing" className="block cursor-pointer" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/v1qgwjHPsQhZVzqTGJyR2G/tiroides-ingles-.webp" alt="The Thyroid Reset Cookbook" className="w-full h-auto object-contain max-w-4xl mx-auto" data-id="element-81" />
          </a>
        </div>

        <div className="mb-4" data-id="element-82">
          <CTAButton className="max-w-md mx-auto" data-id="element-83">
            YES! I WANT INSTANT ACCESS
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-sm text-brand-text-muted" data-id="element-84">
          <span data-id="element-85">Instant Access</span>
          <span data-id="element-86">•</span>
          <span data-id="element-87">Secure Checkout</span>
          <span data-id="element-88">•</span>
          <span data-id="element-89">30-Day Guarantee</span>
        </div>
      </div>
    </section>;
}